import { EvComboboxOption } from '@evinced-private/ui-common';

import { domainInputPlaceholder } from 'src/consts/domainPlaceholderText';
import { SCOPE_ACTIONS } from 'src/types/scope/ScopeActions';
import { SCOPE_TYPES } from 'src/types/scope/ScopeTypes';

import { SCOPE_LABELS } from './ScopeSettingsV2.labels';

export const SCOPE_SETTINGS_TITLE_ID = 'scope-settings-title';
export const SCOPE_SETTINGS_DESCRIPTION_ID = 'scope-settings-description';

type ScopeRuleType = SCOPE_TYPES.URL | SCOPE_TYPES.LANG | SCOPE_TYPES.DOMAIN;

export const DROP_DOWN_OPTIONS: Record<ScopeRuleType, EvComboboxOption[]> = {
	[SCOPE_TYPES.URL]: [
		{ label: SCOPE_LABELS.INCLUDE_REGEX, value: SCOPE_ACTIONS.INCLUDE },
		{ label: SCOPE_LABELS.EXCLUDE_REGEX, value: SCOPE_ACTIONS.EXCLUDE }
	],
	[SCOPE_TYPES.LANG]: [
		{ label: SCOPE_LABELS.INCLUDE_LANGUAGE, value: SCOPE_ACTIONS.INCLUDE },
		{ label: SCOPE_LABELS.EXCLUDE_LANGUAGE, value: SCOPE_ACTIONS.EXCLUDE }
	],
	[SCOPE_TYPES.DOMAIN]: [
		{ label: SCOPE_LABELS.INCLUDE_DOMAIN, value: SCOPE_ACTIONS.INCLUDE },
		{ label: SCOPE_LABELS.EXCLUDE_DOMAIN, value: SCOPE_ACTIONS.EXCLUDE }
	]
};

export const ARIA_LABELS: Record<ScopeRuleType, string> = {
	[SCOPE_TYPES.DOMAIN]: SCOPE_LABELS.ARIA_DOMAIN,
	[SCOPE_TYPES.URL]: SCOPE_LABELS.ARIA_URL_REGEX,
	[SCOPE_TYPES.LANG]: SCOPE_LABELS.ARIA_LANGUAGE
};

export const INPUT_PLACEHOLDERS: Record<ScopeRuleType, string> = {
	[SCOPE_TYPES.DOMAIN]: domainInputPlaceholder,
	[SCOPE_TYPES.URL]: SCOPE_LABELS.URL_PLACEHOLDER,
	[SCOPE_TYPES.LANG]: SCOPE_LABELS.LANG_PLACEHOLDER
};
